(() => {
let $749b345a849d776c$var$blockLinks = [];
const $749b345a849d776c$export$feb22ab44b4951fb = {
    onDocumentLoad: $749b345a849d776c$var$onDocumentLoad
};
const $749b345a849d776c$var$onDocumentLoad = function() {
    /*Handle clicks for blocks with links*/ $749b345a849d776c$var$blockLinks = document.querySelectorAll(".block-link");
    for(let i = 0; i < $749b345a849d776c$var$blockLinks.length; i++){
        $749b345a849d776c$var$blockLinks[i].addEventListener("click", blockLinkPress);
        $749b345a849d776c$var$blockLinks[i].addEventListener("keyup", function(e) {
            if (e.key === "Enter") blockLinkPress(e);
        });
    }
    function blockLinkPress(e) {
        let item = e.currentTarget.querySelector("[href]");
        let link = item.getAttribute("href");
        let target = item.getAttribute("target");
        let download = item.getAttribute("download");
        if (target != null && target == "_blank") window.open(link, "_blank");
        else if (download != null) window.open(link, "_blank");
        else window.location.href = link;
    }
};


var $49c217790058dcc8$exports = {};
(function(global, factory) {
    $49c217790058dcc8$exports = factory();
})($49c217790058dcc8$exports, function() {
    "use strict";
    /*!
   * mustache.js - Logic-less {{mustache}} templates with JavaScript
   * http://github.com/janl/mustache.js
   */ var objectToString = Object.prototype.toString;
    var isArray = Array.isArray || function isArrayPolyfill(object) {
        return objectToString.call(object) === "[object Array]";
    };
    function isFunction(object) {
        return typeof object === "function";
    }
    /**
   * More correct typeof string handling array
   * which normally returns typeof 'object'
   */ function typeStr(obj) {
        return isArray(obj) ? "array" : typeof obj;
    }
    function escapeRegExp(string) {
        return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
    }
    /**
   * Null safe way of checking whether or not an object,
   * including its prototype, has a given property
   */ function hasProperty(obj, propName) {
        return obj != null && typeof obj === "object" && propName in obj;
    }
    /**
   * Safe way of detecting whether or not the given thing is a primitive and
   * whether it has the given property
   */ function primitiveHasOwnProperty(primitive, propName) {
        return primitive != null && typeof primitive !== "object" && primitive.hasOwnProperty && primitive.hasOwnProperty(propName);
    }
    // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
    // See https://github.com/janl/mustache.js/issues/189
    var regExpTest = RegExp.prototype.test;
    function testRegExp(re, string) {
        return regExpTest.call(re, string);
    }
    var nonSpaceRe = /\S/;
    function isWhitespace(string) {
        return !testRegExp(nonSpaceRe, string);
    }
    var entityMap = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
        "/": "&#x2F;",
        "`": "&#x60;",
        "=": "&#x3D;"
    };
    function escapeHtml(string) {
        return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap(s) {
            return entityMap[s];
        });
    }
    var whiteRe = /\s*/;
    var spaceRe = /\s+/;
    var equalsRe = /\s*=/;
    var curlyRe = /\s*\}/;
    var tagRe = /#|\^|\/|>|\{|&|=|!/;
    /**
   * Breaks up the given `template` string into a tree of tokens. If the `tags`
   * argument is given here it must be an array with two string values: the
   * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
   * course, the default is to use mustaches (i.e. mustache.tags).
   *
   * A token is an array with at least 4 elements. The first element is the
   * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
   * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
   * all text that appears outside a symbol this element is "text".
   *
   * The second element of a token is its "value". For mustache tags this is
   * whatever else was inside the tag besides the opening symbol. For text tokens
   * this is the text itself.
   *
   * The third and fourth elements of the token are the start and end indices,
   * respectively, of the token in the original template.
   *
   * Tokens that are the root node of a subtree contain two more elements: 1) an
   * array of tokens in the subtree and 2) the index in the original template at
   * which the closing tag for that section begins.
   *
   * Tokens for partials also contain two more elements: 1) a string value of
   * indendation prior to that tag and 2) the index of that tag on that line -
   * eg a value of 2 indicates the partial is the third tag on this line.
   */ function parseTemplate(template, tags) {
        if (!template) return [];
        var lineHasNonSpace = false;
        var sections = []; // Stack to hold section tokens
        var tokens = []; // Buffer to hold the tokens
        var spaces = []; // Indices of whitespace tokens on the current line
        var hasTag = false; // Is there a {{tag}} on the current line?
        var nonSpace = false; // Is there a non-space char on the current line?
        var indentation = ""; // Tracks indentation for tags that use it
        var tagIndex = 0; // Stores a count of number of tags encountered on a line
        // Strips all whitespace tokens array for the current line
        // if there was a {{#tag}} on it and otherwise only space.
        function stripSpace() {
            if (hasTag && !nonSpace) while(spaces.length)delete tokens[spaces.pop()];
            else spaces = [];
            hasTag = false;
            nonSpace = false;
        }
        var openingTagRe, closingTagRe, closingCurlyRe;
        function compileTags(tagsToCompile) {
            if (typeof tagsToCompile === "string") tagsToCompile = tagsToCompile.split(spaceRe, 2);
            if (!isArray(tagsToCompile) || tagsToCompile.length !== 2) throw new Error("Invalid tags: " + tagsToCompile);
            openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + "\\s*");
            closingTagRe = new RegExp("\\s*" + escapeRegExp(tagsToCompile[1]));
            closingCurlyRe = new RegExp("\\s*" + escapeRegExp("}" + tagsToCompile[1]));
        }
        compileTags(tags || mustache.tags);
        var scanner = new Scanner(template);
        var start, type, value, chr, token, openSection;
        while(!scanner.eos()){
            start = scanner.pos;
            // Match any text between tags.
            value = scanner.scanUntil(openingTagRe);
            if (value) for(var i = 0, valueLength = value.length; i < valueLength; ++i){
                chr = value.charAt(i);
                if (isWhitespace(chr)) {
                    spaces.push(tokens.length);
                    indentation += chr;
                } else {
                    nonSpace = true;
                    lineHasNonSpace = true;
                    indentation += " ";
                }
                tokens.push([
                    "text",
                    chr,
                    start,
                    start + 1
                ]);
                start += 1;
                // Check for whitespace on the current line.
                if (chr === "\n") {
                    stripSpace();
                    indentation = "";
                    tagIndex = 0;
                    lineHasNonSpace = false;
                }
            }
            // Match the opening tag.
            if (!scanner.scan(openingTagRe)) break;
            hasTag = true;
            // Get the tag type.
            type = scanner.scan(tagRe) || "name";
            scanner.scan(whiteRe);
            // Get the tag value.
            if (type === "=") {
                value = scanner.scanUntil(equalsRe);
                scanner.scan(equalsRe);
                scanner.scanUntil(closingTagRe);
            } else if (type === "{") {
                value = scanner.scanUntil(closingCurlyRe);
                scanner.scan(curlyRe);
                scanner.scanUntil(closingTagRe);
                type = "&";
            } else value = scanner.scanUntil(closingTagRe);
            // Match the closing tag.
            if (!scanner.scan(closingTagRe)) throw new Error("Unclosed tag at " + scanner.pos);
            if (type == ">") token = [
                type,
                value,
                start,
                scanner.pos,
                indentation,
                tagIndex,
                lineHasNonSpace
            ];
            else token = [
                type,
                value,
                start,
                scanner.pos
            ];
            tagIndex++;
            tokens.push(token);
            if (type === "#" || type === "^") sections.push(token);
            else if (type === "/") {
                // Check section nesting.
                openSection = sections.pop();
                if (!openSection) throw new Error('Unopened section "' + value + '" at ' + start);
                if (openSection[1] !== value) throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
            } else if (type === "name" || type === "{" || type === "&") nonSpace = true;
            else if (type === "=") // Set the tags for the next time around.
            compileTags(value);
        }
        stripSpace();
        // Make sure there are no open sections when we're done.
        openSection = sections.pop();
        if (openSection) throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);
        return nestTokens(squashTokens(tokens));
    }
    /**
   * Combines the values of consecutive text tokens in the given `tokens` array
   * to a single token.
   */ function squashTokens(tokens) {
        var squashedTokens = [];
        var token, lastToken;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            if (token) {
                if (token[0] === "text" && lastToken && lastToken[0] === "text") {
                    lastToken[1] += token[1];
                    lastToken[3] = token[3];
                } else {
                    squashedTokens.push(token);
                    lastToken = token;
                }
            }
        }
        return squashedTokens;
    }
    /**
   * Forms the given array of `tokens` into a nested tree structure where
   * tokens that represent a section have two additional items: 1) an array of
   * all tokens that appear in that section and 2) the index in the original
   * template that represents the end of that section.
   */ function nestTokens(tokens) {
        var nestedTokens = [];
        var collector = nestedTokens;
        var sections = [];
        var token, section;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            switch(token[0]){
                case "#":
                case "^":
                    collector.push(token);
                    sections.push(token);
                    collector = token[4] = [];
                    break;
                case "/":
                    section = sections.pop();
                    section[5] = token[2];
                    collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
                    break;
                default:
                    collector.push(token);
            }
        }
        return nestedTokens;
    }
    /**
   * A simple string scanner that is used by the template parser to find
   * tokens in template strings.
   */ function Scanner(string) {
        this.string = string;
        this.tail = string;
        this.pos = 0;
    }
    /**
   * Returns `true` if the tail is empty (end of string).
   */ Scanner.prototype.eos = function eos() {
        return this.tail === "";
    };
    /**
   * Tries to match the given regular expression at the current position.
   * Returns the matched text if it can match, the empty string otherwise.
   */ Scanner.prototype.scan = function scan(re) {
        var match = this.tail.match(re);
        if (!match || match.index !== 0) return "";
        var string = match[0];
        this.tail = this.tail.substring(string.length);
        this.pos += string.length;
        return string;
    };
    /**
   * Skips all text until the given regular expression can be matched. Returns
   * the skipped string, which is the entire tail if no match can be made.
   */ Scanner.prototype.scanUntil = function scanUntil(re) {
        var index = this.tail.search(re), match;
        switch(index){
            case -1:
                match = this.tail;
                this.tail = "";
                break;
            case 0:
                match = "";
                break;
            default:
                match = this.tail.substring(0, index);
                this.tail = this.tail.substring(index);
        }
        this.pos += match.length;
        return match;
    };
    /**
   * Represents a rendering context by wrapping a view object and
   * maintaining a reference to the parent context.
   */ function Context(view, parentContext) {
        this.view = view;
        this.cache = {
            ".": this.view
        };
        this.parent = parentContext;
    }
    /**
   * Creates a new context using the given view with this context
   * as the parent.
   */ Context.prototype.push = function push(view) {
        return new Context(view, this);
    };
    /**
   * Returns the value of the given name in this context, traversing
   * up the context hierarchy if the value is absent in this context's view.
   */ Context.prototype.lookup = function lookup(name) {
        var cache1 = this.cache;
        var value;
        if (cache1.hasOwnProperty(name)) value = cache1[name];
        else {
            var context = this, intermediateValue, names, index, lookupHit = false;
            while(context){
                if (name.indexOf(".") > 0) {
                    intermediateValue = context.view;
                    names = name.split(".");
                    index = 0;
                    /**
           * Using the dot notion path in `name`, we descend through the
           * nested objects.
           *
           * To be certain that the lookup has been successful, we have to
           * check if the last object in the path actually has the property
           * we are looking for. We store the result in `lookupHit`.
           *
           * This is specially necessary for when the value has been set to
           * `undefined` and we want to avoid looking up parent contexts.
           *
           * In the case where dot notation is used, we consider the lookup
           * to be successful even if the last "object" in the path is
           * not actually an object but a primitive (e.g., a string, or an
           * integer), because it is sometimes useful to access a property
           * of an autoboxed primitive, such as the length of a string.
           **/ while(intermediateValue != null && index < names.length){
                        if (index === names.length - 1) lookupHit = hasProperty(intermediateValue, names[index]) || primitiveHasOwnProperty(intermediateValue, names[index]);
                        intermediateValue = intermediateValue[names[index++]];
                    }
                } else {
                    intermediateValue = context.view[name];
                    /**
           * Only checking against `hasProperty`, which always returns `false` if
           * `context.view` is not an object. Deliberately omitting the check
           * against `primitiveHasOwnProperty` if dot notation is not used.
           *
           * Consider this example:
           * ```
           * Mustache.render("The length of a football field is {{#length}}{{length}}{{/length}}.", {length: "100 yards"})
           * ```
           *
           * If we were to check also against `primitiveHasOwnProperty`, as we do
           * in the dot notation case, then render call would return:
           *
           * "The length of a football field is 9."
           *
           * rather than the expected:
           *
           * "The length of a football field is 100 yards."
           **/ lookupHit = hasProperty(context.view, name);
                }
                if (lookupHit) {
                    value = intermediateValue;
                    break;
                }
                context = context.parent;
            }
            cache1[name] = value;
        }
        if (isFunction(value)) value = value.call(this.view);
        return value;
    };
    /**
   * A Writer knows how to take a stream of tokens and render them to a
   * string, given a context. It also maintains a cache of templates to
   * avoid the need to parse the same template twice.
   */ function Writer() {
        this.templateCache = {
            _cache: {},
            set: function set(key, value) {
                this._cache[key] = value;
            },
            get: function get(key) {
                return this._cache[key];
            },
            clear: function clear() {
                this._cache = {};
            }
        };
    }
    /**
   * Clears all cached templates in this writer.
   */ Writer.prototype.clearCache = function clearCache() {
        if (typeof this.templateCache !== "undefined") this.templateCache.clear();
    };
    /**
   * Parses and caches the given `template` according to the given `tags` or
   * `mustache.tags` if `tags` is omitted,  and returns the array of tokens
   * that is generated from the parse.
   */ Writer.prototype.parse = function parse(template, tags) {
        var cache1 = this.templateCache;
        var cacheKey = template + ":" + (tags || mustache.tags).join(":");
        var isCacheEnabled = typeof cache1 !== "undefined";
        var tokens = isCacheEnabled ? cache1.get(cacheKey) : undefined;
        if (tokens == undefined) {
            tokens = parseTemplate(template, tags);
            isCacheEnabled && cache1.set(cacheKey, tokens);
        }
        return tokens;
    };
    /**
   * High-level method that is used to render the given `template` with
   * the given `view`.
   *
   * The optional `partials` argument may be an object that contains the
   * names and templates of partials that are used in the template. It may
   * also be a function that is used to load partial templates on the fly
   * that takes a single argument: the name of the partial.
   *
   * If the optional `config` argument is given here, then it should be an
   * object with a `tags` attribute or an `escape` attribute or both.
   * If an array is passed, then it will be interpreted the same way as
   * a `tags` attribute on a `config` object.
   *
   * The `tags` attribute of a `config` object must be an array with two
   * string values: the opening and closing tags used in the template (e.g.
   * [ "<%", "%>" ]). The default is to mustache.tags.
   *
   * The `escape` attribute of a `config` object must be a function which
   * accepts a string as input and outputs a safely escaped string.
   * If an `escape` function is not provided, then an HTML-safe string
   * escaping function is used as the default.
   */ Writer.prototype.render = function render(template, view, partials, config) {
        var tags = this.getConfigTags(config);
        var tokens = this.parse(template, tags);
        var context = view instanceof Context ? view : new Context(view, undefined);
        return this.renderTokens(tokens, context, partials, template, config);
    };
    /**
   * Low-level method that renders the given array of `tokens` using
   * the given `context` and `partials`.
   *
   * Note: The `originalTemplate` is only ever used to extract the portion
   * of the original template that was contained in a higher-order section.
   * If the template doesn't use higher-order sections, this argument may
   * be omitted.
   */ Writer.prototype.renderTokens = function renderTokens(tokens, context, partials, originalTemplate, config) {
        var buffer = "";
        var token, symbol, value;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            value = undefined;
            token = tokens[i];
            symbol = token[0];
            if (symbol === "#") value = this.renderSection(token, context, partials, originalTemplate, config);
            else if (symbol === "^") value = this.renderInverted(token, context, partials, originalTemplate, config);
            else if (symbol === ">") value = this.renderPartial(token, context, partials, config);
            else if (symbol === "&") value = this.unescapedValue(token, context);
            else if (symbol === "name") value = this.escapedValue(token, context, config);
            else if (symbol === "text") value = this.rawValue(token);
            if (value !== undefined) buffer += value;
        }
        return buffer;
    };
    Writer.prototype.renderSection = function renderSection(token, context, partials, originalTemplate, config) {
        var self = this;
        var buffer = "";
        var value = context.lookup(token[1]);
        // This function is used to render an arbitrary template
        // in the current context by higher-order sections.
        function subRender(template) {
            return self.render(template, context, partials, config);
        }
        if (!value) return;
        if (isArray(value)) for(var j = 0, valueLength = value.length; j < valueLength; ++j)buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate, config);
        else if (typeof value === "object" || typeof value === "string" || typeof value === "number") buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate, config);
        else if (isFunction(value)) {
            if (typeof originalTemplate !== "string") throw new Error("Cannot use higher-order sections without the original template");
            // Extract the portion of the original template that the section contains.
            value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);
            if (value != null) buffer += value;
        } else buffer += this.renderTokens(token[4], context, partials, originalTemplate, config);
        return buffer;
    };
    Writer.prototype.renderInverted = function renderInverted(token, context, partials, originalTemplate, config) {
        var value = context.lookup(token[1]);
        // Use JavaScript's definition of falsy. Include empty arrays.
        // See https://github.com/janl/mustache.js/issues/186
        if (!value || isArray(value) && value.length === 0) return this.renderTokens(token[4], context, partials, originalTemplate, config);
    };
    Writer.prototype.indentPartial = function indentPartial(partial, indentation, lineHasNonSpace) {
        var filteredIndentation = indentation.replace(/[^ \t]/g, "");
        var partialByNl = partial.split("\n");
        for(var i = 0; i < partialByNl.length; i++)if (partialByNl[i].length && (i > 0 || !lineHasNonSpace)) partialByNl[i] = filteredIndentation + partialByNl[i];
        return partialByNl.join("\n");
    };
    Writer.prototype.renderPartial = function renderPartial(token, context, partials, config) {
        if (!partials) return;
        var tags = this.getConfigTags(config);
        var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
        if (value != null) {
            var lineHasNonSpace = token[6];
            var tagIndex = token[5];
            var indentation = token[4];
            var indentedValue = value;
            if (tagIndex == 0 && indentation) indentedValue = this.indentPartial(value, indentation, lineHasNonSpace);
            var tokens = this.parse(indentedValue, tags);
            return this.renderTokens(tokens, context, partials, indentedValue, config);
        }
    };
    Writer.prototype.unescapedValue = function unescapedValue(token, context) {
        var value = context.lookup(token[1]);
        if (value != null) return value;
    };
    Writer.prototype.escapedValue = function escapedValue(token, context, config) {
        var escape = this.getConfigEscape(config) || mustache.escape;
        var value = context.lookup(token[1]);
        if (value != null) return typeof value === "number" && escape === mustache.escape ? String(value) : escape(value);
    };
    Writer.prototype.rawValue = function rawValue(token) {
        return token[1];
    };
    Writer.prototype.getConfigTags = function getConfigTags(config) {
        if (isArray(config)) return config;
        else if (config && typeof config === "object") return config.tags;
        else return undefined;
    };
    Writer.prototype.getConfigEscape = function getConfigEscape(config) {
        if (config && typeof config === "object" && !isArray(config)) return config.escape;
        else return undefined;
    };
    var mustache = {
        name: "mustache.js",
        version: "4.2.0",
        tags: [
            "{{",
            "}}"
        ],
        clearCache: undefined,
        escape: undefined,
        parse: undefined,
        render: undefined,
        Scanner: undefined,
        Context: undefined,
        Writer: undefined,
        /**
     * Allows a user to override the default caching strategy, by providing an
     * object with set, get and clear methods. This can also be used to disable
     * the cache by setting it to the literal `undefined`.
     */ set templateCache (cache){
            defaultWriter.templateCache = cache;
        },
        /**
     * Gets the default or overridden caching object from the default writer.
     */ get templateCache () {
            return defaultWriter.templateCache;
        }
    };
    // All high-level mustache.* functions use this writer.
    var defaultWriter = new Writer();
    /**
   * Clears all cached templates in the default writer.
   */ mustache.clearCache = function clearCache() {
        return defaultWriter.clearCache();
    };
    /**
   * Parses and caches the given template in the default writer and returns the
   * array of tokens it contains. Doing this ahead of time avoids the need to
   * parse templates on the fly as they are rendered.
   */ mustache.parse = function parse(template, tags) {
        return defaultWriter.parse(template, tags);
    };
    /**
   * Renders the `template` with the given `view`, `partials`, and `config`
   * using the default writer.
   */ mustache.render = function render(template, view, partials, config) {
        if (typeof template !== "string") throw new TypeError('Invalid template! Template should be a "string" but "' + typeStr(template) + '" was given as the first ' + "argument for mustache#render(template, view, partials)");
        return defaultWriter.render(template, view, partials, config);
    };
    // Export the escaping function so that the user may override it.
    // See https://github.com/janl/mustache.js/issues/244
    mustache.escape = escapeHtml;
    // Export these mainly for testing, but also for advanced usage.
    mustache.Scanner = Scanner;
    mustache.Context = Context;
    mustache.Writer = Writer;
    return mustache;
});


let $94f875d1245cd4dc$var$faqBlocks = [];
let $94f875d1245cd4dc$var$faqButtons = [];
const $94f875d1245cd4dc$export$bcbb932733b48eed = {
    onDocumentLoad: $94f875d1245cd4dc$var$onDocumentLoad
};
const $94f875d1245cd4dc$var$onDocumentLoad = function() {
    /*FAQ*/ $94f875d1245cd4dc$var$faqBlocks = document.getElementsByClassName("faq-block");
    for(let i = 0; i < $94f875d1245cd4dc$var$faqBlocks.length; i++){
        $94f875d1245cd4dc$var$faqButtons = $94f875d1245cd4dc$var$faqBlocks[i].getElementsByTagName("button");
        for(let i = 0; i < $94f875d1245cd4dc$var$faqButtons.length; i++){
            let expand = document.getElementById($94f875d1245cd4dc$var$faqButtons[i].getAttribute("aria-controls"));
            let height = expand.offsetHeight;
            expand.setAttribute("data-height", height);
            expand.style.height = 0;
            $94f875d1245cd4dc$var$faqButtons[i].addEventListener("click", function(e) {
                faqButtonClick(e.currentTarget);
            });
        }
    }
    function faqButtonClick(target) {
        target.setAttribute("aria-expanded", toggleAriaExpanded(target));
        let expand = document.getElementById(target.getAttribute("aria-controls"));
        expand.classList.toggle("open");
        if (expand.classList.contains("open")) expand.style.height = expand.dataset.height + "px";
        else expand.style.height = 0;
    }
    function toggleAriaExpanded(target) {
        let targetExpanded = target.getAttribute("aria-expanded");
        if (targetExpanded == "true") targetExpanded = "false";
        else targetExpanded = "true";
        return targetExpanded;
    }
};



const $fcf4abd278724bfe$var$hiddenFieldGuid = "0e1c0568-776f-4d95-cb15-b5e044d2ac43";
const $fcf4abd278724bfe$export$4e1c4961567893ee = {
    onDocumentLoad: $fcf4abd278724bfe$var$onDocumentLoad
};
const $fcf4abd278724bfe$var$onDocumentLoad = function() {
    var quantityStepperBtns = document.querySelectorAll(".quantity-stepper-btn");
    for(let i = 0; i < quantityStepperBtns.length; i++)quantityStepperBtns[i].addEventListener("click", onQuantityStepperPress);
    function onQuantityStepperPress(e) {
        let target = e.currentTarget;
        let queryString = target.dataset.targetInput;
        let willIncreaseValue = target.dataset.type == "increase";
        let targetIsMobile = target.dataset.targetInput.includes("Mobile");
        if (willIncreaseValue) increaseValue(queryString, targetIsMobile);
        else decreaseValue(queryString, targetIsMobile);
    }
    function increaseValue(queryString, targetIsMobile) {
        let elms = setUpRelatedInputElements(targetIsMobile, queryString);
        let desktopInput = elms[0];
        let mobileInput = elms[1];
        let increaseBtnDesktop = elms[2];
        let increaseBtnMobile = elms[3];
        desktopInput.value++;
        mobileInput.value = desktopInput.value;
        generateOrderState();
        if (desktopInput.value > 0) {
            increaseBtnDesktop.disabled = false;
            increaseBtnMobile.disabled = false;
        }
    }
    function decreaseValue(queryString, targetIsMobile) {
        let elms = setUpRelatedInputElements(targetIsMobile, queryString);
        let desktopInput = elms[0];
        let mobileInput = elms[1];
        let increaseBtnDesktop = elms[2];
        let increaseBtnMobile = elms[3];
        let hash = desktopInput.dataset.hash;
        var summaryWrapperItems = document.querySelectorAll(`li[data-hash='${hash}']`);
        if (summaryWrapperItems.length == 1) handleArticleAdded(hash, false);
        if (desktopInput.value > 0) {
            desktopInput.value--;
            mobileInput.value = desktopInput.value;
            generateOrderState();
        }
        if (desktopInput.value == 0) {
            increaseBtnDesktop.disabled = true;
            increaseBtnMobile.disabled = true;
        }
    }
    var mobileVariants = document.querySelectorAll(".variants-mobile");
    for(let i = 0; i < mobileVariants.length; i++){
        let height = mobileVariants[i].offsetHeight;
        mobileVariants[i].dataset.height = height;
        mobileVariants[i].style.height = 0;
    }
    var variantsToggle = document.querySelectorAll(".variants-toggle");
    for(let i = 0; i < variantsToggle.length; i++)variantsToggle[i].addEventListener("click", onTogglePress);
    function onTogglePress(e) {
        let target = e.currentTarget;
        let expandId = target.getAttribute("aria-controls");
        let expand = document.getElementById(expandId);
        target.setAttribute("aria-expanded", toggleAriaExpanded(target));
        expand.classList.toggle("open");
        if (expand.dataset.height) toggleHeight(expand, expand.dataset.height);
    }
    function toggleHeight(expand, height) {
        if (expand.classList.contains("open")) expand.style.height = height + "px";
        else expand.style.height = 0;
    }
    function toggleAriaExpanded(target) {
        let targetExpanded = target.getAttribute("aria-expanded");
        if (targetExpanded == "true") targetExpanded = "false";
        else targetExpanded = "true";
        return targetExpanded;
    }
    function setUpRelatedInputElements(targetIsMobile, queryString) {
        let inputDesktopQueryString = queryString;
        let inputMobileQueryString = queryString;
        if (targetIsMobile) inputDesktopQueryString = queryString.replace("-Mobile", "");
        else inputMobileQueryString = queryString + "-Mobile";
        let desktopInput = document.getElementById(inputDesktopQueryString);
        let mobileInput = document.getElementById(inputMobileQueryString);
        let increaseBtnDesktop = document.querySelectorAll(`[data-target-input="${inputDesktopQueryString}"]`);
        let increaseBtnMobile = document.querySelectorAll(`[data-target-input="${inputMobileQueryString}"]`);
        let elms = [
            desktopInput,
            mobileInput,
            increaseBtnDesktop[1],
            increaseBtnMobile[0]
        ];
        return elms;
    }
    var changeAmount = document.querySelectorAll(".change-amount");
    for(let i = 0; i < changeAmount.length; i++){
        let oldValue = null;
        let newValue = null;
        changeAmount[i].addEventListener("focus", function(e) {
            this.select();
        });
        changeAmount[i].addEventListener("keyup", function(e) {
            let targetIsMobile = e.currentTarget.id.includes("Mobile");
            let queryString = e.currentTarget.id;
            let elms = setUpRelatedInputElements(targetIsMobile, queryString);
            let desktopInput = elms[0];
            let mobileInput = elms[1];
            let increaseBtnDesktop = elms[2];
            let increaseBtnMobile = elms[3];
            if (e.which !== 40 || e.which !== 38) {
                if (changeAmount[i].value == null || changeAmount[i].value == "") changeAmount[i].value = oldValue;
                else {
                    newValue = changeAmount[i].value;
                    if (targetIsMobile) desktopInput.value = newValue;
                    else mobileInput.value = newValue;
                    if (changeAmount[i].value == 0) {
                        increaseBtnDesktop.disabled = true;
                        increaseBtnMobile.disabled = true;
                    } else {
                        increaseBtnDesktop.disabled = false;
                        increaseBtnMobile.disabled = false;
                    }
                    generateOrderState();
                }
                if (newValue != oldValue) oldValue = newValue;
            }
        });
        changeAmount[i].addEventListener("keydown", function(e) {
            let targetIsMobile = e.currentTarget.id.includes("Mobile");
            let queryString = e.currentTarget.id;
            if (e.which === 38) {
                e.preventDefault();
                increaseValue(queryString, targetIsMobile);
            }
            if (e.which === 40) {
                e.preventDefault();
                decreaseValue(queryString, targetIsMobile);
            }
            if (changeAmount[i].value == null || changeAmount[i].value == "") changeAmount[i].value = oldValue;
            else newValue = changeAmount[i].value;
        });
        if (changeAmount.length) generateOrderState();
    }
    function generateOrderState(keepSummaryOpen) {
        var products = document.querySelectorAll("[data-product]");
        var totalAmount = 0;
        var open = keepSummaryOpen ? "open" : "";
        var result = {
            "products": [],
            "hasProducts": function() {
                return this.products.length;
            },
            "totalAmount": totalAmount,
            "open": open
        };
        for(let i = 0; i < products.length; i++){
            var title = products[i].getAttribute("data-product-title");
            var hash = products[i].getAttribute("data-product");
            var item = {
                title: title,
                hash: hash,
                open: open,
                variations: []
            };
            var variations = products[i].querySelectorAll("[data-variation]");
            for(let j = 0; j < variations.length; j++){
                var variantTitle = variations[j].getAttribute("data-variation-title");
                var amount = parseInt(variations[j].value);
                var hash = variations[j].getAttribute("data-hash");
                var id = variations[j].id;
                var totalAmountTemp = totalAmount;
                if (amount > 0) {
                    totalAmount = totalAmountTemp + amount;
                    var variation = {
                        "title": variantTitle,
                        "amount": amount,
                        "id": id,
                        hash: hash
                    };
                    item.variations.push(variation);
                }
            }
            if (item.variations.length) result.products.push(item);
        }
        result.totalAmount = totalAmount;
        /* Update Mustache render */ const mustacheTemplate = document.getElementById("order-item-template").innerHTML;
        const mustacheContainer = document.getElementById("mustache-container");
        const mustacheRendered = $49c217790058dcc8$exports.render(mustacheTemplate, result);
        mustacheContainer.innerHTML = mustacheRendered;
        var summaryToggle = document.querySelectorAll(".order-summary-toggle");
        for(let i = 0; i < summaryToggle.length; i++)summaryToggle[i].addEventListener("click", onTogglePress);
        var anchorButtons = mustacheContainer.querySelectorAll("[data-anchor]");
        for(let i = 0; i < anchorButtons.length; i++){
            anchorButtons[i].addEventListener("click", onAnchorPress);
            anchorButtons[i].addEventListener("keyup", onAnchorPress);
        }
        var removeVariationButtons = mustacheContainer.querySelectorAll("[data-remove-variation]");
        for(let i = 0; i < removeVariationButtons.length; i++){
            //TODO Update remove logic
            var button = removeVariationButtons[i];
            button.addEventListener("click", onRemoveVariationPress);
            button.addEventListener("keyup", onRemoveVariationPress);
        }
        let summaryWrapperItems = document.querySelectorAll("li[data-hash]");
        for(var i = 0; i < summaryWrapperItems.length; i++)handleArticleAdded(summaryWrapperItems[i].dataset.hash, true);
        if (!result.products.length) {
            document.getElementById("order-form").classList.add("hidden");
            window.scrollTo(0, 0);
        } else {
            // parse the object and set it to a hidden form field that will be sent to backend.
            var hiddenJsonDataField = document.querySelector(`[name='${$fcf4abd278724bfe$var$hiddenFieldGuid}']`);
            if (hiddenJsonDataField !== undefined) hiddenJsonDataField.value = JSON.stringify(result);
        }
    }
    function onRemoveVariationPress(e) {
        if (e.key === undefined || e.key === "Enter") {
            var id = e.currentTarget.dataset.removeVariation;
            let elms = setUpRelatedInputElements(false, id);
            let desktopInput = elms[0];
            let mobileInput = elms[1];
            let increaseBtnDesktop = elms[2];
            let increaseBtnMobile = elms[3];
            desktopInput.value = 0;
            mobileInput.value = 0;
            increaseBtnDesktop.disabled = true;
            increaseBtnMobile.disabled = true;
            handleArticleAdded(e.currentTarget.dataset.hash, false);
            generateOrderState(true);
        }
    }
    function handleArticleAdded(hash, isAdded) {
        let article = document.querySelector(`article[data-product='${hash}']`);
        if (isAdded) article.classList.add("added");
        else article.classList.remove("added");
    }
    function onAnchorPress(e) {
        if (e.key === undefined || e.key === "Enter") {
            e.preventDefault();
            var targetId = e.currentTarget.getAttribute("data-anchor");
            let target = document.getElementById(targetId);
            target.classList.remove("hidden");
            target.scrollIntoView({
                behavior: "smooth"
            });
        }
    }
    var sectionFilterChips = document.querySelectorAll("[data-product-section-filter]");
    function handleFilterChipsChange() {
        var activeFilterChips = [];
        for(let i = 0; i < sectionFilterChips.length; i++){
            var filterChip = sectionFilterChips[i];
            if (filterChip.classList.contains("active")) {
                var target = filterChip.getAttribute("data-target");
                if (target !== undefined && target !== null) activeFilterChips.push(target);
            }
        }
        var productSections = document.querySelectorAll("[data-section]");
        for(let i = 0; i < productSections.length; i++){
            var sectionName = productSections[i].getAttribute("data-section");
            if (!activeFilterChips.includes(sectionName) && activeFilterChips.length) productSections[i].classList.add("hidden");
            else productSections[i].classList.remove("hidden");
        }
    }
    for(let i = 0; i < sectionFilterChips.length; i++)sectionFilterChips[i].addEventListener("click", function(e) {
        e.preventDefault();
        e.currentTarget.classList.toggle("active");
        var countElement = e.currentTarget.querySelector("[data-count]");
        var countActive = [
            "bg-base-light",
            "text-base-dark",
            "border-base-light"
        ];
        var countInactive = [
            "border-base-dark"
        ];
        var btnActive = [
            "text-base-onDark",
            "bg-base-dark",
            "hover:bg-base-hoverDark"
        ];
        if (e.currentTarget.classList.contains("active")) {
            countElement.classList.add(...countActive);
            e.currentTarget.classList.add(...btnActive);
            countElement.classList.remove(...countInactive);
        } else {
            countElement.classList.remove(...countActive);
            e.currentTarget.classList.remove(...btnActive);
            countElement.classList.add(...countInactive);
        }
        handleFilterChipsChange();
    });
};


const $da9198d3767da401$export$6d5c1d5931889e38 = {
    onDocumentLoad: $da9198d3767da401$var$onDocumentLoad
};
const $da9198d3767da401$var$onDocumentLoad = function() {
    var request = new XMLHttpRequest();
    request.open("GET", "/images/spritesheet.svg?v=2");
    request.send();
    request.onreadystatechange = function() {
        if (request.readyState == XMLHttpRequest.DONE) {
            if (request.status == 200) {
                var data = request.responseText;
                var svgContainer = document.getElementById("svg-icons");
                svgContainer.innerHTML = data;
            } else console.error("Couldn't load SVG spritesheet");
        }
    };
};


let $43f1375b38f583e3$var$shareLink = null;
let $43f1375b38f583e3$var$shareLinkConfirmation = null;
const $43f1375b38f583e3$export$969ee752695d93ee = {
    onDocumentLoad: $43f1375b38f583e3$var$onDocumentLoad
};
const $43f1375b38f583e3$var$onDocumentLoad = function() {
    /*Share link*/ $43f1375b38f583e3$var$shareLink = document.getElementById("shareLink");
    $43f1375b38f583e3$var$shareLinkConfirmation = document.getElementById("shareLinkConfirmation");
    if ($43f1375b38f583e3$var$shareLink) $43f1375b38f583e3$var$shareLink.addEventListener("click", function(e) {
        navigator.clipboard.writeText(window.location.href);
        setTimeout(()=>{
            $43f1375b38f583e3$var$shareLinkConfirmation.classList.remove("hidden");
        }, 250);
        setTimeout(()=>{
            $43f1375b38f583e3$var$shareLinkConfirmation.classList.add("hidden");
        }, 3250);
    });
};


const $807a31536fa4a9f2$export$2b14f6bb59cf46da = {
    onDocumentLoad: $807a31536fa4a9f2$var$onDocumentLoad
};
const $807a31536fa4a9f2$var$onDocumentLoad = function() {
    /*skip to content*/ /*skip to main content*/ let main = document.querySelectorAll("main");
    let focusable = main[0].querySelectorAll("button, [href], select, textarea");
    let firstFocusable = focusable[0];
    let skipToContent = document.getElementById("skipToContent");
    skipToContent.addEventListener("click", function() {
        firstFocusable.focus();
    });
};


/* Binds to region dropdowns when filtering Event / Group pages */ const $c4fca5833a0c1c49$export$4034a70b04efa1b7 = {
    onDocumentLoad: $c4fca5833a0c1c49$var$onDocumentLoad
};
const $c4fca5833a0c1c49$var$onDocumentLoad = function() {
    var disallowedQueryParameters = [
        "p",
        "city"
    ];
    var dropdown = document.getElementById("regions");
    if (dropdown !== undefined && dropdown !== null) {
        const searchParams = new URLSearchParams(window.location.search);
        disallowedQueryParameters.forEach((e)=>{
            searchParams.delete(e);
        });
        dropdown.addEventListener("change", function(e) {
            const changedValue = e.target.value;
            var queryName = e.target.getAttribute("name");
            if (changedValue.length > 0) searchParams.set(queryName, changedValue);
            window.location.search = searchParams;
        });
    }
};


let $1df32a4945e9e156$var$expandBtns = [];
let $1df32a4945e9e156$var$menuExpandBtns = [];
let $1df32a4945e9e156$var$subExpandBtns = [];
let $1df32a4945e9e156$var$mainMenu = null;
let $1df32a4945e9e156$var$overlay = null;
let $1df32a4945e9e156$var$subMenus = [];
let $1df32a4945e9e156$var$mobileMenuWrapper = null;
let $1df32a4945e9e156$var$searchClear = [];
let $1df32a4945e9e156$var$searchInput = [];
let $1df32a4945e9e156$var$searchForm = [];
let $1df32a4945e9e156$var$searchHeader = null;
let $1df32a4945e9e156$var$searchWrapper = null;
let $1df32a4945e9e156$var$searchToggle = null;
let $1df32a4945e9e156$var$searchSubmit = null;
let $1df32a4945e9e156$var$header = null;
let $1df32a4945e9e156$var$headerHeight = "";
let $1df32a4945e9e156$var$body = null;
let $1df32a4945e9e156$var$lastScroll = 0;
window.addEventListener("load", (e)=>{
    (0, $da9198d3767da401$export$6d5c1d5931889e38).onDocumentLoad();
    $1df32a4945e9e156$var$header = document.getElementById("header");
    $1df32a4945e9e156$var$headerHeight = $1df32a4945e9e156$var$header.offsetHeight;
    $1df32a4945e9e156$var$body = document.body;
    /* Load any relevant modules for this page */ /* TODO: Implement support to only run needed modules per page. */ (0, $fcf4abd278724bfe$export$4e1c4961567893ee).onDocumentLoad();
    (0, $94f875d1245cd4dc$export$bcbb932733b48eed).onDocumentLoad();
    (0, $43f1375b38f583e3$export$969ee752695d93ee).onDocumentLoad();
    (0, $749b345a849d776c$export$feb22ab44b4951fb).onDocumentLoad();
    (0, $807a31536fa4a9f2$export$2b14f6bb59cf46da).onDocumentLoad();
    (0, $c4fca5833a0c1c49$export$4034a70b04efa1b7).onDocumentLoad();
    $1df32a4945e9e156$var$overlay = document.getElementById("overlay");
    $1df32a4945e9e156$var$expandBtns = document.querySelectorAll("[data-expand-target]");
    $1df32a4945e9e156$var$subExpandBtns = document.querySelectorAll("[data-sub-expand-target]");
    $1df32a4945e9e156$var$menuExpandBtns = document.querySelectorAll("[data-menu-target]");
    $1df32a4945e9e156$var$mainMenu = document.getElementById("mainMenu");
    $1df32a4945e9e156$var$subMenus = document.querySelectorAll(".sub-menu");
    $1df32a4945e9e156$var$searchHeader = document.getElementById("searchHeader");
    $1df32a4945e9e156$var$searchWrapper = document.getElementById("searchWrapper");
    $1df32a4945e9e156$var$searchToggle = document.getElementById("searchToggle");
    $1df32a4945e9e156$var$searchSubmit = $1df32a4945e9e156$var$searchWrapper.querySelector("input[type=submit]");
    $1df32a4945e9e156$var$mobileMenuWrapper = document.getElementById("mobileMenuWrapper");
    // Get sub-menu height
    for(let i = 0; i < $1df32a4945e9e156$var$subMenus.length; i++){
        let height = $1df32a4945e9e156$var$subMenus[i].offsetHeight;
        $1df32a4945e9e156$var$subMenus[i].setAttribute("data-height", height);
        $1df32a4945e9e156$var$subMenus[i].style.height = 0;
    }
    // mobile-sub-menu height
    let mobileSubMenu = document.querySelectorAll(".mobile-sub-menu");
    for(let i = 0; i < mobileSubMenu.length; i++){
        let height = mobileSubMenu[i].offsetHeight;
        mobileSubMenu[i].setAttribute("data-height", height);
        mobileSubMenu[i].style.height = 0;
    }
    //Get searchWrapper height
    $1df32a4945e9e156$var$searchWrapper.setAttribute("data-height", $1df32a4945e9e156$var$searchWrapper.offsetHeight);
    $1df32a4945e9e156$var$searchWrapper.style.height = 0;
    /*Main menu keyboard nav */ let mainMenuButtons = $1df32a4945e9e156$var$mainMenu.querySelectorAll(".main-menu-item");
    for(let i = 0; i < mainMenuButtons.length; i++){
        mainMenuButtons[i].addEventListener("click", function(e) {
            expandMenu(e.currentTarget, document.getElementById(e.currentTarget.dataset.menuTarget));
        });
        mainMenuButtons[i].addEventListener("focus", function(e) {
            // Check if tab has focus from keyboard
            if (hasPseudoClass(e.currentTarget, ":focus-visible")) {
                // Check if target is search or menu toggle
                if (e.currentTarget.dataset.expandTarget) // Make sure previuos target wasn't search input
                {
                    if (e.relatedTarget && e.relatedTarget.dataset.menuTarget) closeMenus(true);
                } else {
                    closeSearch();
                    expandMenu(e.currentTarget, document.getElementById(e.currentTarget.dataset.menuTarget));
                }
            }
        });
        mainMenuButtons[i].addEventListener("keydown", function(e) {
            if (e.key === "Enter" && e.currentTarget.getAttribute("aria-expanded")) {
                // Prevent enter to open menu
                e.preventDefault();
                // Check if target is menu or search toggle
                if (e.currentTarget.dataset.expandTarget == "searchWrapper") {
                    let expand = document.getElementById(e.currentTarget.dataset.expandTarget);
                    // Get the element to focus for header toggle
                    let focusOn = document.getElementById(e.currentTarget.dataset.setFocusOn);
                    if (expand) toggleHeaderSearch(e.currentTarget, expand, focusOn);
                }
                if (e.currentTarget.dataset.expandTarget == "mobileMenuWrapper") {
                    let expand = document.getElementById(e.currentTarget.dataset.expandTarget);
                    toggleMobileMenu(e.currentTarget, expand);
                }
            }
            if (e.key === "ArrowDown") {
                e.preventDefault();
                focusSubItems(e.currentTarget, document.getElementById(e.currentTarget.dataset.menuTarget));
            }
        });
    }
    //Check if focus is set by keyboard
    function hasPseudoClass(node, selector) {
        var nativeMatches = node.matches || node.msMatchesSelector;
        try {
            return nativeMatches.call(node, selector);
        } catch (error) {
            return false;
        }
    }
    //Expand submnenu
    function expandMenu(target, expand) {
        if (!target.classList.contains("open") && target.dataset.menuTarget) closeMenus(false);
        if (expand) {
            if (target.getAttribute("aria-expanded") == "true") {
                expand.classList.add("toggled");
                setTimeout(()=>{
                    expand.classList.remove("toggled");
                }, 301);
            }
            target.classList.toggle("open");
            target.setAttribute("aria-expanded", toggleAriaExpanded(target));
            expand.classList.toggle("open");
            if (target.getAttribute("aria-expanded") == "true") {
                closeSearch(null, true);
                expand.style.height = expand.dataset.height + "px";
                lockScroll();
            } else {
                expand.style.height = 0;
                releaseScroll();
            }
            $1df32a4945e9e156$var$overlay.classList.toggle("hide");
            window.addEventListener("keydown", function(e) {
                if (e.key === "Escape") closeMenus(true);
            });
        } else if (target.dataset.menuTarget) closeMenus(true);
    }
    //Set focus on subitems
    function focusSubItems(target, expand) {
        let expandFocusable = expand.querySelectorAll("[href]");
        let currentIndex = 0;
        expandFocusable[0].focus();
        expand.addEventListener("keydown", function(e) {
            if (e.key === "ArrowDown") {
                e.preventDefault();
                currentIndex++;
                if (expandFocusable[currentIndex]) expandFocusable[currentIndex].focus();
                else {
                    currentIndex = 0;
                    expandFocusable[currentIndex].focus();
                }
            }
            if (e.key === "ArrowUp") {
                e.preventDefault();
                currentIndex--;
                if (expandFocusable[currentIndex]) expandFocusable[currentIndex].focus();
                else {
                    currentIndex = expandFocusable.length - 1;
                    expandFocusable[currentIndex].focus();
                }
            }
            if (e.key === "Tab") {
                const arr = Array.from(mainMenuButtons);
                let index = arr.indexOf(target);
                mainMenuButtons[index].focus();
            }
        });
    }
    /*Expand header elements - search & mobile menu*/ for(let i = 0; i < $1df32a4945e9e156$var$expandBtns.length; i++)$1df32a4945e9e156$var$expandBtns[i].addEventListener("click", function(e) {
        let expand = document.getElementById(e.currentTarget.dataset.expandTarget);
        let focusOn = document.getElementById(e.currentTarget.dataset.setFocusOn);
        if (e.currentTarget.dataset.expandTarget == "mobileMenuWrapper") toggleMobileMenu(e.currentTarget, expand);
        else toggleHeaderSearch(e.currentTarget, expand, focusOn);
    });
    function toggleHeaderSearch(target, expand, focusOn) {
        expand.classList.toggle("open");
        target.setAttribute("aria-expanded", toggleAriaExpanded(target));
        if (expand.classList.contains("open")) {
            closeMobileMenu();
            //TODO CLOSE SEARCH
            closeMenus();
            releaseScroll();
            lockScroll(false);
            expand.style.height = expand.dataset.height + "px";
            $1df32a4945e9e156$var$overlay.classList.remove("hide");
        } else {
            releaseScroll();
            $1df32a4945e9e156$var$searchHeader.value = "";
            expand.style.height = 0;
            $1df32a4945e9e156$var$overlay.classList.add("hide");
        }
        setTimeout(()=>{
            focusOn.focus();
        }, 301);
        initSearchHeader();
        window.addEventListener("keydown", function(e) {
            if (e.key === "Escape") closeSearch(target);
        });
    }
    function closeSearch(target, preventAnimation) {
        if (!$1df32a4945e9e156$var$overlay.classList.contains("hide")) $1df32a4945e9e156$var$overlay.classList.add("hide");
        let labelledBy = $1df32a4945e9e156$var$searchWrapper.getAttribute("aria-labelledby");
        let expandBtn = document.getElementById(labelledBy);
        expandBtn.setAttribute("aria-expanded", false);
        $1df32a4945e9e156$var$searchWrapper.classList.remove("open");
        if (target != undefined || target != null) target.focus();
        if (preventAnimation) {
            $1df32a4945e9e156$var$searchWrapper.classList.add("hidden");
            setTimeout(()=>{
                $1df32a4945e9e156$var$searchWrapper.classList.remove("hidden");
            }, 301);
        }
        $1df32a4945e9e156$var$searchWrapper.style.height = 0;
        $1df32a4945e9e156$var$searchHeader.value = "";
    }
    //Handle search clear
    $1df32a4945e9e156$var$searchClear = document.querySelectorAll(".clear-search");
    for(let i = 0; i < $1df32a4945e9e156$var$searchClear.length; i++){
        $1df32a4945e9e156$var$searchClear[i].addEventListener("click", function(e) {
            let clearInput = document.getElementById(e.currentTarget.dataset.clearSearch);
            e.preventDefault();
            clearSerch($1df32a4945e9e156$var$searchClear[i], clearInput);
        });
        $1df32a4945e9e156$var$searchClear[i].addEventListener("keyup", function(e) {
            if (e.key === "Enter") {
                let clearInput = document.getElementById(e.currentTarget.dataset.clearSearch);
                e.preventDefault();
                clearSerch($1df32a4945e9e156$var$searchClear[i], clearInput);
            }
        });
    }
    function clearSerch(searchClear, clearInput) {
        e.preventDefault();
        searchClear.classList.add("hidden");
        clearInput.value = "";
        clearInput.focus();
    }
    //Handle search input
    $1df32a4945e9e156$var$searchInput = document.querySelectorAll("input[type=search]");
    for(let i = 0; i < $1df32a4945e9e156$var$searchInput.length; i++)$1df32a4945e9e156$var$searchInput[i].addEventListener("keyup", function(e) {
        let clearInput = document.getElementById($1df32a4945e9e156$var$searchInput[i].id + "Clear");
        if ($1df32a4945e9e156$var$searchInput[i].value.length > 0) clearInput.classList.remove("hidden");
        else clearInput.classList.add("hidden");
        if (e.key === "Enter") {
            e.preventDefault();
            if ($1df32a4945e9e156$var$searchInput[i].value.length > 0) e.currentTarget.form.submit();
        }
    });
    //Handle tab loop for header search
    function initSearchHeader() {
        $1df32a4945e9e156$var$searchSubmit.addEventListener("blur", function(e) {
            $1df32a4945e9e156$var$searchToggle.focus();
        });
    }
    //Handle search submiting form
    $1df32a4945e9e156$var$searchForm = document.querySelectorAll(".search-form");
    for(let i = 0; i < $1df32a4945e9e156$var$searchForm.length; i++){
        let formInput = $1df32a4945e9e156$var$searchForm[i].querySelectorAll("input");
        $1df32a4945e9e156$var$searchForm[i].addEventListener("submit", function(e) {
            e.preventDefault();
            if (formInput[0].value.length > 0) $1df32a4945e9e156$var$searchForm[i].submit();
        });
    }
    function toggleMobileMenu(target, expand) {
        expand.classList.toggle("open");
        target.setAttribute("aria-expanded", toggleAriaExpanded(target));
        if (expand.classList.contains("open")) {
            lockScroll(true);
            $1df32a4945e9e156$var$overlay.classList.remove("hide");
            closeSearch(null, true);
        } else {
            releaseScroll();
            closeMobileSubMenus();
            $1df32a4945e9e156$var$overlay.classList.add("hide");
        }
    }
    function lockScroll(isMobile) {
        //Prevent scrolling the content below the menu by setting it to an fixed postion
        $1df32a4945e9e156$var$body.classList.add("menuOpen");
        if (isMobile) $1df32a4945e9e156$var$body.classList.add("mobileMenuOpen");
    }
    function releaseScroll() {
        setTimeout(()=>{
            $1df32a4945e9e156$var$body.classList.remove("menuOpen");
            $1df32a4945e9e156$var$body.classList.remove("mobileMenuOpen");
            $1df32a4945e9e156$var$body.classList.add("scrollUp");
        }, 3);
    }
    /*Mobile sub menu expand button*/ for(let i = 0; i < $1df32a4945e9e156$var$subExpandBtns.length; i++)$1df32a4945e9e156$var$subExpandBtns[i].addEventListener("click", function(e) {
        let expand = document.getElementById(e.currentTarget.dataset.subExpandTarget);
        if (expand) {
            expand.classList.toggle("open");
            e.currentTarget.setAttribute("aria-expanded", toggleAriaExpanded(e.currentTarget));
            if (expand.classList.contains("open")) expand.style.height = expand.dataset.height + "px";
            else expand.style.height = 0;
        }
    });
    function toggleAriaExpanded(target) {
        let targetExpanded = target.getAttribute("aria-expanded");
        if (targetExpanded == "true") targetExpanded = "false";
        else targetExpanded = "true";
        return targetExpanded;
    }
    /* Overlay - hide and close all expanded */ $1df32a4945e9e156$var$overlay.addEventListener("click", function(e) {
        closeMenus(true);
        closeSearch();
        releaseScroll();
    });
    function closeMenus(toggleMenuItem) {
        //Close main menus
        for(let i = 0; i < $1df32a4945e9e156$var$menuExpandBtns.length; i++){
            $1df32a4945e9e156$var$menuExpandBtns[i].classList.remove("open");
            $1df32a4945e9e156$var$menuExpandBtns[i].setAttribute("aria-expanded", false);
            let close = document.getElementById($1df32a4945e9e156$var$menuExpandBtns[i].dataset.menuTarget);
            close.classList.remove("open");
            close.style.height = 0;
            if (toggleMenuItem) {
                close.classList.add("toggled");
                setTimeout(()=>{
                    close.classList.remove("toggled");
                }, 301);
            }
        }
        $1df32a4945e9e156$var$overlay.classList.add("hide");
    }
    //Close mobile main menu
    function closeMobileMenu() {
        let labelledBy = $1df32a4945e9e156$var$mobileMenuWrapper.getAttribute("aria-labelledby");
        let expandBtn = document.getElementById(labelledBy);
        expandBtn.setAttribute("aria-expanded", false);
        $1df32a4945e9e156$var$mobileMenuWrapper.classList.add("hidden");
        setTimeout(()=>{
            $1df32a4945e9e156$var$mobileMenuWrapper.classList.remove("open");
            $1df32a4945e9e156$var$mobileMenuWrapper.classList.remove("hidden");
        }, 301);
        closeMobileSubMenus();
        $1df32a4945e9e156$var$overlay.classList.add("hide");
    }
    function closeMobileSubMenus() {
        for(let i = 0; i < $1df32a4945e9e156$var$subExpandBtns.length; i++){
            let sibling = $1df32a4945e9e156$var$subExpandBtns[i].previousElementSibling;
            if (!sibling.classList.contains("active")) {
                $1df32a4945e9e156$var$subExpandBtns[i].setAttribute("aria-expanded", false);
                let close = document.getElementById($1df32a4945e9e156$var$subExpandBtns[i].dataset.subExpandTarget);
                close.classList.remove("open");
                close.classList.add("closing-mobile-menu");
                setTimeout(()=>{
                    close.style.height = 0;
                    close.classList.remove("closing-mobile-menu");
                }, 301);
            }
        }
    }
});
window.addEventListener("scroll", ()=>{
    const currentScroll = window.scrollY;
    if (!$1df32a4945e9e156$var$body.classList.contains("menuOpen")) {
        if (currentScroll > $1df32a4945e9e156$var$headerHeight) $1df32a4945e9e156$var$body.classList.add("scrolledPast");
        else $1df32a4945e9e156$var$body.classList.remove("scrolledPast");
        if (currentScroll < $1df32a4945e9e156$var$lastScroll && $1df32a4945e9e156$var$body.classList.contains("scrolledPast")) $1df32a4945e9e156$var$body.classList.add("scrollUp");
        else $1df32a4945e9e156$var$body.classList.remove("scrollUp");
    }
    $1df32a4945e9e156$var$lastScroll = currentScroll;
});

})();
//# sourceMappingURL=script.js.map
